"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_ACTION_PAYLOAD_TOO_LARGE = void 0;
exports.appActionPayloadExcess = appActionPayloadExcess;
exports.appActionPayloadTooLargeMessage = appActionPayloadTooLargeMessage;
const app_base_contract_1 = require("./app-base-contract");
exports.APP_ACTION_PAYLOAD_TOO_LARGE = 'APP_ACTION_PAYLOAD_TOO_LARGE';
/** Size of the complete JSON command input, before schema parsing. */
function appActionPayloadExcess(value) {
    const limitBytes = app_base_contract_1.APP_BASE_BUDGETS.maxActionPayloadBytes;
    const payloadBytes = new TextEncoder().encode(JSON.stringify(value)).byteLength;
    return payloadBytes > limitBytes ? { limitBytes, payloadBytes } : null;
}
function appActionPayloadTooLargeMessage(limitBytes) {
    return `App action payload exceeds ${limitBytes} bytes`;
}
